module.exports = __webpack_public_path__ + "media/images/icons/phone-89cd8e0dd5ddc5c2bd96a364097945f6.svg";